import { MyCatalogRegisterRepository } from '../repositories/my_catalog_register_repository';
import { MyCatalogRegisterView } from '../views/pc/my_catalog_register/my_catalog_register_views';
import {
  MY_CATALOG_CLUB_URL, MY_CATALOG_SOLOARE_URL, MY_CATALOG_TRYLION_URL,
  MyCatalogRegisterAction,
} from '../actions/my_catalog_register/my_catalog_register_action';
import { MyCatalogRegisterAnalytics } from '../actions/analytics/my_catalog_register_action_analytics';
import { isClub, isSoloare } from '../models/js_env';
import RedirectUtil from './redirect_util';
import { Env } from '../env';

const MESSAGE = '商品を登録するフォルダがありません';

const TRANSITION_URL = '/tpc/mycatalog/myCatalogInst/insertGoods/?ctgItemCd=';

export class MyCatalogRegisterModal {
  public async viewMyCatalogRegisterModal(event: Event, supplierId: string, catalogItemCode: string, medicalMaterialType: string) {

    /// お気に入りフォルダ一覧参照API
    const result = await new MyCatalogRegisterRepository().getFavoriteFolderList(catalogItemCode, supplierId);

    /// エラー処理
    if (result.errorCode === '1' || result.errorCode === '2') {
      /// APIのエラーコード１または２(未ログイン)の場合
      const clubRedirectUrl = TRANSITION_URL + catalogItemCode + '&transitionBackURL=' + location.pathname + location.search;
      const soloareRedirectUrl = location.pathname + location.search;
      RedirectUtil.toLoginPage(clubRedirectUrl, soloareRedirectUrl);
      return;
    }

    /// お気に入り追加モーダル読み込み
    this.readMyCatalogAddModal();

    /// お気に入り完了モーダル読み込み
    this.readMyCatalogCompleteModal();

    /// 表示制御
    this.displayControl(result, supplierId, catalogItemCode, medicalMaterialType);

    /// 簡易完了モーダルのセットアップ
    this.setupSimpleCompleteModal(event);

     /// 遷移
    const myCatalogRegisterOpenButtonHidden = document.getElementById('myCatalogRegisterOpenButtonHidden') as HTMLInputElement;
    myCatalogRegisterOpenButtonHidden.click();
  }

  private displayControl(result, supplierId: string, catalogItemCode: string, medicalMaterialType: string): void {
    const folderCreateButton = document.getElementById('folderCreateButton') as HTMLInputElement;
    const folderDetail = document.getElementById('folderDetail') as HTMLInputElement;
    const errorMessage = document.getElementById('my_catalog_errorMessage') as HTMLInputElement;
    const errorMessageArea = document.getElementById('my_catalog_errorMessageArea') as HTMLInputElement;
    const message = document.getElementById('message') as HTMLInputElement;
    const soloareMessage = document.getElementById('my_catalog_soloareMessage') as HTMLInputElement;

    /// TODO フォルダ新規作成ボタン R1では表示しない。R2以降仕様変更
    folderCreateButton.style.display = 'none';

    /// 「選択したフォルダに登録」ボタン非活性
    (document.querySelector('#my-catalog-insert-selected-folder') as HTMLButtonElement)?.setAttribute('disabled', 'true');

    const count = result.personalFolders.length + result.departmentFolders.length + result.companyFolders.length;
    if (count === 0) {
      let url = "";
      if (isClub(Env.SITE_TYPE)) {
        /// CLUB
        url = MY_CATALOG_CLUB_URL;
      }else if(isSoloare(Env.SITE_TYPE)){
        /// SOLOARE
        url = MY_CATALOG_SOLOARE_URL;
      }else{
        /// TRYLION(R2以降)
        url = MY_CATALOG_TRYLION_URL;
      }
      /// 個人・部門・企業の表示件数が0件の場合、一覧非表示、エラーメッセージ・メッセージ変更
      folderDetail.style.display = 'none';
      message.innerText = MESSAGE;
      errorMessage.innerHTML = `先に<a class="a-textlink" href=${url}>マイカタログ</a>で新規フォルダを作成してください。`;

      /// 個人・部門・企業の表示件数が0件、かつソロアリの場合、メッセージ表示
      if (isSoloare(Env.SITE_TYPE)) {
        soloareMessage.innerHTML = 'フォルダのご登録がない場合はマイカタログの画面からフォルダを追加したのち、しばらくしてから再度ご登録ください。';
      }
      return;
    }

    /// エラーメッセージ領域非表示
    errorMessageArea.style.display = 'none';

    /// 選択したフォルダに登録 html生成（イベントリスナー重複防止対策）
    const myCatalogInsertSelectedFolderInner: HTMLLIElement = <HTMLLIElement>document.querySelector('#my-catalog-insert-selected-folder-inner');
    if (myCatalogInsertSelectedFolderInner) {
      document.getElementById('my-catalog-insert-selected-folder')?.remove();
      myCatalogInsertSelectedFolderInner.innerHTML += MyCatalogRegisterView.createMyCatalogInsertSelectedFolderInner();
    }

    /// フォルダ一覧制御
    /// 個人用フォルダ html作成
    const personal: HTMLLIElement = <HTMLLIElement>document.querySelector('#personal');
    if (personal) {
      personal.innerHTML = MyCatalogRegisterView.createFolderHtml(result.personalFolders, "個人用フォルダ", true, result.registeredFolderCodes);
    }
    /// 部門共有フォルダ html作成
    const department: HTMLLIElement = <HTMLLIElement>document.querySelector('#department');
    if (department) {
      department.innerHTML = MyCatalogRegisterView.createFolderHtml(result.departmentFolders, "部門共有フォルダ", result.isDisplayDepartmentFolders, result.registeredFolderCodes);
    }
    /// 企業共有フォルダ html作成
    const company: HTMLLIElement = <HTMLLIElement>document.querySelector('#company');
    if (company) {
      company.innerHTML =  MyCatalogRegisterView.createFolderHtml(result.companyFolders, "共有フォルダ", result.isDisplayCompanyFolders, result.registeredFolderCodes);
    }

    /// お気に入り追加モーダル「選択したフォルダに登録」クリック時のイベント追加
    MyCatalogRegisterAction.myCatalogInsertSelectedFolder(
      supplierId,
      catalogItemCode,
      medicalMaterialType
    );

    /// アコーディオンjs 再読み込み
    this.readWindowAccordion();

    /// フォルダー制御js 再読み込み
    this.readWindowAddFolder();

    /// RRエリアカルーセルjs 再読み込み
    this.readWindowCarousel();

    /// 選択フォルダ変更イベント生成
    const inputRadioButton: any = document.querySelectorAll("input[name=myCatalogFolder]");
    for(const element of inputRadioButton) {
      element.addEventListener('change', function(e){
        const target = e.target as HTMLInputElement;
        if(target.checked) {
          const myCatalogRegisterCompleteMessage = document.getElementById('myCatalogRegisterCompleteMessage') as HTMLInputElement;
          myCatalogRegisterCompleteMessage.innerText = `${target.dataset.folderName}に商品を登録しました。`;
        }
      });
    }
  }

  /// アコーディオン 再読み込み
  private readWindowAccordion(): any {
    const WindowAccordion = (window as any)._accordion;
    return new WindowAccordion('#folderDetail');
  }

  /// フォルダー制御 再読み込み
  private readWindowAddFolder(): any {
    const WindowFolder = (window as any)._addfolder
    return new WindowFolder();
  }

  /// RRエリアカルーセル 再読み込み
  private readWindowCarousel(): any {
    const WindowCarousel = (window as any)._carousel
    return new WindowCarousel('#recomRR_myCataModal_01-carousel');
  }

  /// お気に入り追加モーダル読み込み
  private readMyCatalogAddModal() {

    const CommonModal = (window as any)._modal;

    class MyCatalogAddModal extends CommonModal {
      constructor(){
        super('data-my-catalog-add-trigger', 'data-my-catalog-add-close');
      }
    }

    return new MyCatalogAddModal();
  }

  /// お気に入り登録完了 モーダル読み込み
  private readMyCatalogCompleteModal() {

    const CommonModal = (window as any)._modal;

    class MyCatalogCompleteModal extends CommonModal {
      constructor(){
        super('data-my-catalog-complete-trigger', 'data-my-catalog-complete-close');
      }

      open() {
        /// 初期処理
        /// マイカタログを見るの遷移先を設定する
        const myCatalogLink = document.getElementById('myCatalogLink') as HTMLInputElement;
        if(myCatalogLink){
          if (isClub(Env.SITE_TYPE)) {
            /// CLUB
            myCatalogLink.setAttribute('href', MY_CATALOG_CLUB_URL);
          }else if(isSoloare(Env.SITE_TYPE)){
            /// SOLOARE
            myCatalogLink.setAttribute('href', MY_CATALOG_SOLOARE_URL);
          }else{
            /// TRYLION(R2以降)
            myCatalogLink.setAttribute('href', MY_CATALOG_TRYLION_URL);
          }
        }

        /// 一定期間表示チェックボックスクリック処理
        document.getElementById('myCatalogRegisterViewCheckbox')?.addEventListener('click', function (e) {
          const target = e.target as HTMLInputElement;
          if(target.checked){
            MyCatalogRegisterAction.checkedMyCatalogRegisterViewCheckbox();
          }else{
            MyCatalogRegisterAction.uncheckedMyCatalogRegisterViewCheckbox();
          }
        });

      }
    }
    return new MyCatalogCompleteModal();
  }

  private setupSimpleCompleteModal(event: Event) {

    // domに別のボタンから呼び出されたマイカタログ簡易完了モーダルがあれば削除
    document.querySelector('div#myCatalog-register-simple-complete-modal-setup')?.remove();

    let div: HTMLDivElement = <HTMLDivElement>document.createElement('div');
    div.setAttribute('id', 'myCatalog-register-simple-complete-modal-setup');

    // 簡易完了モーダルhtml取得
    div.innerHTML = MyCatalogRegisterView.getSimpleCompleteModalHtml();

    // クリックした「お気に入り追加モーダル」呼び出しボタンの下に簡易完了モーダルを追加する
    (event!.target as HTMLButtonElement).after(div);

    let WindowTooltip = window._tooltip;
    return new WindowTooltip(div);
  }

}
(window as any).MyCatalogRegisterModal = new MyCatalogRegisterModal();

///　お気に入り登録完了　AdobeAnalytics計測
(window as any).MyCatalogRegisterAnalytics = new MyCatalogRegisterAnalytics();
